// extracted by mini-css-extract-plugin
export var columnList = "_dg-0";